<form
	#editForm="ngForm"
	[formReset]="editForm"
	(ngSubmit)="editForm.valid && submit()">
	<div class="modal-header">
		<h4
			class="modal-title"
			*ngIf="!loading">
			{{'labels.' + title | translate}}
		</h4>
		<button
			type="button"
			class="close"
			aria-label="Close"
			(click)="dismiss()">
			<span aria-hidden="true">×</span>
		</button>
	</div>
	<div
		class="modal-body"
		ngbAutofocus>
		<div
			class="row"
			*ngIf="loading">
			<div class="col text-center">
				<app-loader [material]="false"></app-loader>
			</div>
		</div>

		<div
			class="row"
			*ngIf="!loading && cost">
			<div class="col-sm-12">
				<div class="row">
					<!-- activity -->
					<div class="form-group col-md-6">
						<label for="activityinput">{{ 'labels.activity' | translate }}*</label>

						<app-entity-autocomplete
							entityName="activity"
							entityField="name"
							entityFilterType="like"
							[entitySearch]="search.activity"
							name="activity"
							[(ngModel)]="selected.activity"
							placeholder
							required
							#activityautocomplete="ngModel"
							[ngClass]="{'is-invalid': editForm.submitted && activityautocomplete.invalid}">
						</app-entity-autocomplete>
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && activityautocomplete.invalid"
							style="display: block;">
							{{'errors.required' | translate}}
						</div>

					</div>
					<div class="form-group col-md-6">
						<label>{{'labels.type' | translate}}*</label>
						<select
							class="form-control custom-select"
							[(ngModel)]="cost.activitytype"
							required
							#activitytype="ngModel"
							name="activitytype"
							[ngClass]="{'is-invalid': editForm.submitted && activitytype.invalid}">
							<option
								*ngFor="let u of types"
								[value]="u.itemvalue">
								{{u.itemlabel}}
							</option>
						</select>
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && activitytype.invalid"
							style="display: block;">
							{{'errors.required' | translate}}
						</div>
					</div>
					<div class="form-group col-md-6">
						<label>{{'labels.name' | translate}}*</label>
						<input
							type="text"
							class="form-control"
							name="cname"
							[(ngModel)]="cost.name"
							required
							#cname="ngModel"
							[ngClass]="{'is-invalid': editForm.submitted && cname.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && cname.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>

					<div class="form-group col-md-6">
						<label>{{'labels.amount' | translate}}*</label>
						<input
							type="number"
							class="form-control"
							name="intmin"
							[(ngModel)]="cost.cost"
							required
							#amount="ngModel"
							[ngClass]="{'is-invalid': editForm.submitted && amount.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && amount.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>

					<!-- description -->
					<div class="form-group col-md-12">
						<label>{{ 'labels.description' | translate }}</label>
						<textarea
							[(ngModel)]="cost.description"
							#description="ngModel"
							name="description"
							type="text"
							class="form-control"
							placeholder="{{ 'labels.description' | translate }}"
							[ngClass]="{'is-invalid': editForm.submitted && description.invalid}">
						</textarea>
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && description.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
				</div>
			</div>

		</div>
	</div>
	<div class="modal-footer">

		<button
			type="reset"
			class="btn btn-secondary">
			{{'labels.reset' | translate}}
		</button>
		<button
			type="button"
			class="btn btn-secondary"
			(click)="dismiss()">
			{{'labels.cancel' | translate}}
		</button>
		<button
			type="submit"
			class="btn btn-primary">
			{{'labels.save' | translate}}
		</button>
	</div>
</form>
